import React from "react";
import { TopBanner } from "./Banner";
import { MobileHeader } from "./MobileHeader";
import Nav from "./Nav";
import { useHeaderQuery } from "../../hooks/queries/useHeaderQuery";

export const Header = () => {
  const navData = useHeaderQuery() as Queries.kontent_item_homepage_elements;
  const { phone, email } = navData;

  return (
    <header className="relative w-full">
      <div className="hidden lg:block shadow-lg">
        <TopBanner phone={phone?.value} email={email?.value} />
        <Nav navData={navData} />
      </div>
      <MobileHeader navData={navData} />
    </header>
  );
};
